'use client';
import { useCallback, useState } from 'react';

import { switchChain as switchChainWagmi } from '@wagmi/core';

import { useAccount, useDisconnect } from 'wagmi';

// eslint-disable-next-line deprecate/import
import { wagmiConfig, type WagmiConfigChain } from '@shared/common/providers/LegacyWeb3Provider/wagmi';
import displayWalletErrorToast from '@shared/helpers/displayWalletErrorToast';

type SwitchChainProps = {
  destChainId: number;
  catchErrors?: boolean;
  terminateConnectionOnError?: boolean;
};

export const useSwitchChain = () => {
  const { disconnectAsync } = useDisconnect();
  const { chain } = useAccount();
  const [isSwitching, setIsSwitching] = useState(false);

  const switchChain = useCallback(
    async ({
      destChainId,
      catchErrors = false,
      terminateConnectionOnError = true,
    }: SwitchChainProps) => {
      try {
        if (destChainId && chain?.id && chain.id !== destChainId) {
          setIsSwitching(true);

          await switchChainWagmi(wagmiConfig, {
            chainId: destChainId as WagmiConfigChain['id'],
          });
        }
      } catch (error) {
        if (terminateConnectionOnError) {
          await disconnectAsync();
        }

        if (!catchErrors) {
          throw error;
        }

        displayWalletErrorToast({ error });
      } finally {
        setIsSwitching(false);
      }
    },
    [disconnectAsync, chain?.id],
  );

  return {
    switchChain,
    activeChain: chain?.id,
    isSwitching,
  };
};
